import { render, staticRenderFns } from "./AvaliacaoDetalhes.vue?vue&type=template&id=c0961848&"
import script from "./AvaliacaoDetalhes.vue?vue&type=script&lang=js&"
export * from "./AvaliacaoDetalhes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports